import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        skill: '<',
        onClose: '&',
        onUpdate: '&'
    },
    template: `
        <div class="modal-header">
            <button type="button" class="close" ng-click="vm.onClose()"></button>
            <h2>{{ 'user.Edit skill: ' | translate }} {{ vm.skill.name }}</h2>
        </div>
        <form ng-submit="vm.save()" class="form">
            <div class="modal-body">
                <form-wrapper form="vm.form">
                    <form-row error="vm.form.errors.name">
                        <label class="label">{{ 'user.Skill name' | translate }} *</label>
                        <div class="items">
                            <input ng-model="vm.form.model.name" type="text" class="form-control">
                            <form-row-error></form-row-error>
                        </div>
                    </form-row>
                    <form-row error="vm.form.errors.description">
                        <label class="label">{{ 'user.Skill Description' | translate }} *</label>
                        <div class="items">
                            <input ng-model="vm.form.model.description" type="text" class="form-control">
                            <form-row-error></form-row-error>
                        </div>
                    </form-row>
                    <form-row error="vm.form.errors.defaultUserSkillLevel">
                        <label class="label">{{ 'user.Default user skill level' | translate }} *</label>
                        <div class="items">
                            <input ng-model="vm.form.model.defaultUserSkillLevel" type="text" class="form-control small">
                            <form-row-error></form-row-error>
                        </div>
                    </form-row>
                </form-wrapper>
            </div>
            <div class="modal-footer" >
                    <ul class="actions01">
                        <li class="primary">
                            <button class="btn main" type="button" ng-click="vm.save()">{{ 'general.Save' | translate }}</button>
                        </li>
                        <li>
                            <button class="btn discrete" type="button" ng-click="vm.uibModalInstance.dismiss()">{{ 'general.Cancel' | translate }}</button>
                        </li>
                    </ul>
                </div>
        </form>
    `
})
export default class {
    constructor (FormFactory) {
        this.FormFactory = FormFactory;
    }

    $onInit () {
        this.form = this.FormFactory.createFromResource(this.skill);
    }

    save () {
        this.form.save().then(updatedSkill => {
            this.onUpdate({ updatedSkill });
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/modals/competence/skill/edit/index.js